import removeUndefined from './removeUndefined';

// This is a duplication of the code in Aha! For now copy paste is fine. It's
// far easier than somehow linking to another package. Could be an easy middle
// ground to expose mapColorFromColorPickerToDarkMode on window.
export const PALETTE_COLORS_LIGHT_THEME_TO_DARK = {
  '#ee9999': '#a83b3b',
  '#e24d4d': '#872929',
  '#d50000': '#731717',
  '#aa0000': '#590909',
  '#800000': '#400000',
  '#fdd4a3': '#99672b',
  '#fbb35f': '#875c29',
  '#f9931a': '#6e4516',
  '#c77615': '#543208',
  '#955810': '#3c2000',
  '#ffee99': '#a39241',
  '#ffe24d': '#857428',
  '#ffd500': '#6b5c15',
  '#ccaa00': '#524608',
  '#998000': '#382f00',
  '#dfefc5': '#75943b',
  '#c8e29a': '#5c7a25',
  '#b0d66e': '#476314',
  '#8dab58': '#324a07',
  '#6a8042': '#1e3000',
  '#c1e39d': '#5f8f2b',
  '#93cd54': '#4c781d',
  '#64b80a': '#3b6111',
  '#509308': '#284707',
  '#3c6e06': '#1a3300',
  '#bddcdd': '#389394',
  '#8cc1c3': '#22797a',
  '#5ba7a9': '#146566',
  '#498687': '#084b4d',
  '#376465': '#003233',
  '#99c7ec': '#226eab',
  '#4d9ddd': '#1a5c91',
  '#0173cf': '#0173cf',
  '#015ca6': '#015ca6',
  '#01457c': '#01457c',
  '#c5dfe9': '#408199',
  '#9ac8d9': '#29708a',
  '#6fb0c8': '#165870',
  '#598da0': '#094257',
  '#436a78': '#002d3e',
  '#c2b7c8': '#9775a9',
  '#95829e': '#815d92',
  '#674c75': '#5d3a6f',
  '#523d5e': '#432653',
  '#3e2e46': '#2f143d',
  '#ddbec7': '#a3526b',
  '#c38d9e': '#8a3751',
  '#a95c74': '#701c36',
  '#874a5d': '#570921',
  '#653746': '#3d0013',
  '#f7c6c3': '#a34841',
  '#f09c95': '#8a2f29',
  '#ea7168': '#701c16',
  '#bb5a53': '#570e09',
  '#8c443e': '#3d0400',
  '#f1e2cf': '#99764d',
  '#e7cdab': '#805c2e',
  '#dcb787': '#664214',
  '#b0926c': '#4d2e08',
  '#846e51': '#341d00',
  '#000000': '#e8eef3',
  '#4c4c4c': '#cbd5de',
  '#666666': '#b3bcc4',
  '#7f7f7f': '#9ca4ab',
  '#a5a5a5': '#78828a',
  '#cccccc': '#5a6673',
  '#d9d9d9': '#48525c',
  '#e5e5e5': '#3c454d',
  '#f2f2f2': '#2d363d',
  '#ffffff': '#21282e',
};

const HIGHLIGHTS_LIGHT_THEME_TO_DARK = {
  '#ffff9d': '#6b5c15',
  '#f1f1f1': '#3c454d',
  '#e5f3d6': '#3b6111',
  '#d4e8f7': '#01457c',
  '#fbebeb': '#590909',
};

const TEXT_LIGHT_THEME_TO_DARK = {
  '#999999': 'var(--aha-gray-200)',
  '#f9931a': '#f99319',
  '#64b80b': '#7bba34',
  '#ffffff': 'var(--aha-gray-100)',
};

export const COLORS = [
  '#ee9999',
  '#fdd4a3',
  '#ffee99',
  '#dfefc5',
  '#c1e39d',
  '#bddcdd',
  '#99c7ec',
  '#c5dfe9',
  '#c2b7c8',
  '#ddbec7',
  '#f7c6c3',
  '#f1e2cf',
  '#a5a5a5',
  '#ffffff',
  '#e24d4d',
  '#fbb35f',
  '#ffe24d',
  '#c8e29a',
  '#93cd54',
  '#8cc1c3',
  '#4d9ddd',
  '#9ac8d9',
  '#95829e',
  '#c38d9e',
  '#f09c95',
  '#e7cdab',
  '#7f7f7f',
  '#f2f2f2',
  '#d50000',
  '#f9931a',
  '#ffd500',
  '#b0d66e',
  '#64b80a',
  '#5ba7a9',
  '#0173cf',
  '#6fb0c8',
  '#674c75',
  '#a95c74',
  '#ea7168',
  '#dcb787',
  '#666666',
  '#e5e5e5',
  '#aa0000',
  '#c77615',
  '#ccaa00',
  '#8dab58',
  '#509308',
  '#498687',
  '#015ca6',
  '#598da0',
  '#523d5e',
  '#874a5d',
  '#bb5a53',
  '#b0926c',
  '#4c4c4c',
  '#d9d9d9',
  '#800000',
  '#955810',
  '#998000',
  '#6a8042',
  '#3c6e06',
  '#376465',
  '#01457c',
  '#436a78',
  '#3e2e46',
  '#653746',
  '#8c443e',
  '#846e51',
  '#000000',
  '#cccccc',
];

const utils = {
  foreground() {
    return utils.darkMode() ? '#e8eef3' : '#333333';
  },

  defaultColors() {
    return {
      foreground: utils.foreground(),
      background: 'transparent',
    };
  },
  getColorFromMark(mark) {
    return removeUndefined({
      foreground: mark.data.get('foreground'),
      background: mark.data.get('background'),
      gradient: mark.data.get('gradient'),
    });
  },
  getCurrentColor(editor) {
    const colorMarks = editor
      .getActiveMarks()
      .filter((mark) => mark.type === 'color');

    if (colorMarks.size === 0) return;

    const color = utils.getColorFromMark(colorMarks.first());

    if (
      colorMarks.every((mark) => {
        return utils.isSameColor(color, utils.getColorFromMark(mark));
      })
    ) {
      return color;
    }
  },
  getStyleFromMark(mark, addDefaults = true) {
    if (mark.type !== 'color') {
      return {};
    }

    let color = utils.getColorFromMark(mark);

    if (addDefaults) {
      color = utils.addDefaultsToColor(color);
    }

    let gradientSettings = {};
    if (color.gradient) {
      gradientSettings = {
        backgroundImage: `-webkit-linear-gradient(left, ${color.gradient.gradientStart} 10%, ${color.gradient.gradientEnd} 80%)`,
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundColor: 'transparent',
        color: color.gradient.gradientStart,
      };
    }

    return removeUndefined({
      color: color.foreground ? utils.mapTextColor(color.foreground) : null,
      backgroundColor: color.background
        ? utils.mapHighlightColor(color.background)
        : null,
      ...gradientSettings,
    });
  },
  addDefaultsToColor(color) {
    return { ...utils.defaultColors(), ...removeUndefined(color) };
  },
  isSameColor(color1, color2) {
    return (
      color1.foreground === color2.foreground &&
      color1.background === color2.background &&
      color1.gradient === color2.gradient
    );
  },
  rgbToHex(color) {
    if (color.substr(0, 1) === '#') {
      return color;
    }

    const digits = /(.*?)rgb\((\d+), (\d+), (\d+)\)/.exec(color);
    if (!digits) return color;

    const red = parseInt(digits[2], 10);
    const green = parseInt(digits[3], 10);
    const blue = parseInt(digits[4], 10);

    const rgb = blue | (green << 8) | (red << 16);
    return `${digits[1]}#${rgb.toString(16).padStart(6, '0')}`.toUpperCase();
  },
  normalizeTextColor(color?: string) {
    if (color) {
      color = utils.removeOpacityFromColor(color);
      color = utils.rgbToHex(color);
    }

    if (
      color &&
      ![utils.defaultColors().foreground, '#000000', ''].includes(color)
    ) {
      return color;
    }
  },
  normalizeTextHighlight(color?: string) {
    if (color) {
      color = utils.removeOpacityFromColor(color);
      color = utils.rgbToHex(color);
    }

    if (
      color &&
      ![utils.defaultColors().background, '#FFFFFF', ''].includes(color)
    ) {
      return color;
    }
  },
  mapColorFromColorPickerToDarkMode(color, force = false) {
    return utils.darkMode() || force
      ? PALETTE_COLORS_LIGHT_THEME_TO_DARK[color.toLowerCase()] || color
      : color;
  },
  mapColorFromColorPickerFromDarkMode(color) {
    if (!utils.darkMode()) {
      return color;
    }

    color = color.toLowerCase();

    return (
      Object.keys(PALETTE_COLORS_LIGHT_THEME_TO_DARK).find(
        (key) => PALETTE_COLORS_LIGHT_THEME_TO_DARK[key] === color
      ) ?? color
    );
  },
  mapTextColor(color) {
    return utils.darkMode()
      ? TEXT_LIGHT_THEME_TO_DARK[color.toLowerCase()] || color
      : color;
  },
  mapHighlightColor(color) {
    return utils.darkMode()
      ? HIGHLIGHTS_LIGHT_THEME_TO_DARK[color.toLowerCase()] || color
      : color;
  },
  darkMode() {
    if (typeof document === 'undefined') return false;

    return Boolean(document?.body?.getAttribute('data-theme') === 'dark');
  },
  isValidHexColor(hex: string) {
    return /^#([0-9A-F]{3}){1,2}$/i.test(hex);
  },
  removeOpacityFromColor(color: string) {
    // Handle rgba
    color = color.replace(
      /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*[\d.]+)?\)/g,
      (_, r: string, g: string, b: string) => `rgb(${r}, ${g}, ${b})`
    );

    // Handle hsla
    color = color.replace(
      /hsla\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(?:,\s*[\d.]+)?\)/g,
      (_, h: string, s: string, l: string) => `hsl(${h}, ${s}%, ${l}%)`
    );

    // Handle 8-digit hex (#RRGGBBAA) to 6-digit hex
    color = color.replace(/#([0-9a-fA-F]{6})[0-9a-fA-F]{2}/g, '#$1');

    // Handle 4-digit hex (#RGBA) to 3-digit hex
    color = color.replace(
      /#([0-9a-fA-F]{3})[0-9a-fA-F](?:[^0-9a-fA-F]|$)/g,
      `#$1`
    );

    // Return the modified HTML
    return color;
  },
};

export const DARK_COLORS = COLORS.map((color) =>
  utils.mapColorFromColorPickerToDarkMode(color, true)
);

export default utils;
